/**
 * The Census API returns data formatted as [[header1, header2],[data1, data2]].
 * Use this function to convert it to a more useable JSON.
 * From LazyDeveloper at https://stackoverflow.com/questions/44173385/array-of-arrays-to-json
 */
function arrayOfArrayToJson(array) { 
	var objArray = [];
	for (var i = 1; i < array.length; i++) {
		objArray[i - 1] = {};
		for (var k = 0; k < array[0].length && k < array[i].length; k++) {
			var key = array[0][k];
			objArray[i - 1][key] = array[i][k]
		}
	}

	return objArray;
}

/**
 * 
 * @param {number} year : ACS year
 * @param {number} oneYearOrFive : 1 or 5 for 1-year or 5-year ACS sample
 * @param {boolean} tableType : "subject" for tables like S1701, "profile" for tables like DP05, or "detailed" for detailed tables
 * @param {array of strings} varsList : array/list of variables, such as ['NAME', 'B02015_009E', 'B02015_009M']. See https://www.census.gov/data/developers/data-sets/acs-1year.html
 * @param {string} forGeoScope : geography type such as "county" or "state" for use in the &for= API call.
 * @param {array of strings} forGeo : array/list of states, counties, etc. for which you want data, such as ["081", "073"]. This will be combined with the forGeoScope into something like "&for=county:081,073". Use strings to ensure leading zeros. Use ["*"] for all of the geography (this should be combined with the "inGeo" parameter below). 
 * @param {string} inGeoScope : geography type such as "county" or "state" for use in the &in= API call.
 * @param {array of strings} inGeo :  array/list of states, counties, etc. WITHIN which you want data. This acts as a filter. For example, ["01", "02"]. This will be combined with the inGeoScope into something like "&for=state:01,02". Use strings to ensure leading zeros.
 * 
 * See geography query format at https://www.census.gov/data/developers/guidance/api-user-guide.Query_Components.html.
 * 
 */

export function getCensusData(year, oneYearOrFive, tableType, varsList = [], forGeoType, forGeos = ['*'], inGeoType, inGeos = []) {

	const CENSUS_KEY = '0e3e5795cd0335f3faefb832e3f7c9b086d25998';

  let subject
  if (tableType === "subject") {
    subject =  "/subject"
  } else if (tableType === "profile") {
    subject = "/profile"
  } else {
    subject = ""
  }
	let vars = varsList.join(',');
	let forG = forGeos.length > 0 ? `&for=${forGeoType}:${forGeos.join(',')}` : '';
	let inG = inGeos.length > 0 ? `&in=${inGeoType}:${inGeos.join(',')}` : '';

	let apiString = `https://api.census.gov/data/${String(year)}/acs/acs${String(oneYearOrFive)}${subject}?&key=${CENSUS_KEY}&get=${vars}${forG}${inG}`;
  console.log('Census API query:', apiString)

	return fetch(apiString)
	.then(function(response) { 
		return response.json(); 
	})
	.then(function(response) {
		//Convert Census API response to proper JSON
		let data = arrayOfArrayToJson(response);

		//For requested variables, replace strings with numeric 
		data.forEach(function(d) {
			for (let i = 0; i < varsList.length; i++) {
				d[varsList[i]] = isNaN(+d[varsList[i]]) ? d[varsList[i]] : +d[varsList[i]];
			}
		});

		return data;
	})
	.catch(function(error) { 
		console.log(error); 
	});

}


